/**
 * Attendance clock widget.
 * Attaches best-effort geolocation evidence before submitting the clock
 * form, and guards against double submits. Location denial or timeout
 * never blocks the submission — the server-side IP gate is the real check.
 */
import { setupAttendanceGeo } from './attendance-geo.js';

export function setupAttendanceClock() {
    // GPS 수집이 켜져 있고 위치 권한이 차단된 경우, 브라우저는 다시 묻지
    // 않으므로 재허용 방법을 안내한다 (출퇴근 자체는 GPS 없이도 진행됨).
    const gpsForm = document.querySelector('.attendance-clock-form[data-gps="1"]');
    const hint = document.getElementById('attendance-gps-hint');
    if (gpsForm && hint && navigator.permissions && navigator.permissions.query) {
        navigator.permissions
            .query({ name: 'geolocation' })
            .then((status) => {
                if (status.state === 'denied') hint.style.display = 'block';
            })
            .catch(() => {});
    }

    // 위치로 출퇴근하는 날(data-geo="1")은 attendance-geo.js 가 단추를 맡는다 — 위치를 확인한 뒤에 보낸다.
    setupAttendanceGeo();

    document.querySelectorAll('.attendance-clock-form:not([data-geo="1"])').forEach((form) => {
        form.addEventListener('submit', (e) => {
            // A real user re-click (or double-click) after we've already
            // committed to submitting: block it. `form.submit()` below does
            // NOT fire this handler again, so this flag only ever guards
            // genuine re-entrancy from the user, never our own finish().
            if (form.dataset.submitting === '1') {
                e.preventDefault();
                return;
            }
            const btn = form.querySelector('button:not([type="button"])');
            const setPending = () => {
                if (!btn) return;
                btn.disabled = true;
                btn.classList.add('att-btn-pending');
                btn.textContent = form.dataset.pendingLabel || '기록 중…';
            };
            // GPS 증빙이 꺼져 있으면(관리자 설정, 기본값) 위치 권한을 요청하지
            // 않고 폼을 그대로 제출한다 — 권한 팝업 자체가 뜨지 않는다.
            if (form.dataset.gps !== '1' || !navigator.geolocation) {
                form.dataset.submitting = '1';
                setPending();
                return; // no preventDefault: the single native submit proceeds
            }
            e.preventDefault();
            // Mark submitting and disable the button synchronously, before any
            // async geolocation work starts, so a rapid second click is always
            // caught by the guard above instead of racing past it.
            form.dataset.submitting = '1';
            setPending();

            let done = false;
            const finish = () => {
                if (done) return;
                done = true;
                form.submit();
            };

            const timer = setTimeout(finish, 3000);
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    clearTimeout(timer);
                    form.querySelector('input[name="lat"]').value = pos.coords.latitude;
                    form.querySelector('input[name="lng"]').value = pos.coords.longitude;
                    finish();
                },
                () => {
                    clearTimeout(timer);
                    finish();
                },
                { timeout: 2500, maximumAge: 60000 }
            );
        });
    });
}
